/* eslint-disable max-len */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import './Icon.css';

const Icon = () => (
    <div id='icon'style={{ height: '75px', width: '75px' }}>
<svg viewBox="0 0 7.68 7.68" xmlns="http://www.w3.org/2000/svg" data-name="JuDev Icon" id="JuDev_Icon" style={{ height: '75px' }}>
    <path
    fillRule="evenodd"
    fill="#8c1627"
    transform="translate(-86.528 0.156)"
    d="M91.9,1.366a2.777,2.777,0,0,0-3.57.435.349.349,0,0,0,.147.569l.337.112a.342.342,0,0,0,.35-.078,1.758,1.758,0,0,1,2.529.121.351.351,0,0,0,.493.033l.4-.348a.35.35,0,0,1,.542.109,3.083,3.083,0,0,1-1.274,4.062.346.346,0,0,0-.173.377l.013.063a.349.349,0,0,0,.51.235,3.84,3.84,0,0,0,1.018-5.94.35.35,0,0,0-.491-.028l-.266.236a.461.461,0,0,1-.569.042ZM88.7,3.118a1.736,1.736,0,0,0-.093.566,1.759,1.759,0,0,0,1.253,1.685.34.34,0,0,1,.242.264l.073.348a.35.35,0,0,1-.419.412,2.778,2.778,0,0,1-2.167-2.709c0-.057,0-.113,0-.169a.462.462,0,0,0-.319-.471l-.338-.112a.351.351,0,0,1-.223-.44A3.842,3.842,0,0,1,92.371.407a.338.338,0,0,1,.166.267.338.338,0,0,1-.116.292l-.047.042a.344.344,0,0,1-.414.039,3.079,3.079,0,0,0-4.153.928.349.349,0,0,0,.176.524l.5.176a.35.35,0,0,1,.217.443Zm2.01,2.293a1.77,1.77,0,0,0,1.414-1.727,1.811,1.811,0,0,0-.046-.406.341.341,0,0,1,.107-.341l.266-.237a.35.35,0,0,1,.566.158,2.78,2.78,0,0,1-1.412,3.311.461.461,0,0,0-.248.512l.072.348a.351.351,0,0,1-.271.413,3.843,3.843,0,0,1-4.633-3.758c0-.032,0-.064,0-.1a.35.35,0,0,1,.459-.324l.061.021a.346.346,0,0,1,.24.338v.06A3.079,3.079,0,0,0,90.17,6.757a.349.349,0,0,0,.365-.415c-.033-.173-.065-.346-.1-.521A.351.351,0,0,1,90.713,5.411Z">
        </path>
        <path
        fillRule="evenodd"
        fill="#bfbe5f"
        transform="translate(-86.528 0.156)"
        d="M90.368,4.8a1.12,1.12,0,1,0-1.12-1.12A1.122,1.122,0,0,0,90.368,4.8Z">
            </path>
            </svg>
    </div>
);

export default Icon;
